<div fxFlex fxLayout="column" class="ce-cookie-dialog">
    <h1><strong>Your cookie settings</strong></h1>
    <br />
    <p>We use cookies and store data such as IP addresses for two purposes.</p>
    <br />
    <h2><strong>Essential cookies</strong></h2>
    <p>Essential cookies are necessary for this web service to work properly. These cookies are always active.</p>
    <br />
    <h2><strong>Analytics cookies</strong></h2>
    <p>
        Analytics cookies are used to collect usage analytics data. We use this data to understand how the service is
        used and to improve your experience with it.
    </p>
    <br />
    <div class="cookie-checkbox" *ngIf="defaultValue">
        <mat-radio-button
            class="accept-checkbox"
            name="cookie_choice"
            value="accept"
            (click)="updateUserChoiceStatus(true)"
            (keydown.enter)="updateUserChoiceStatus(true)"
            checked
            >Accept analytics cookies</mat-radio-button
        >
        <br />
        <mat-radio-button
            class="decline-checkbox"
            name="cookie_choice"
            value="decline"
            (click)="updateUserChoiceStatus(false)"
            (keydown.enter)="updateUserChoiceStatus(false)"
        >
            Decline analytics cookies</mat-radio-button
        >
    </div>
    <div class="cookie-checkbox" *ngIf="!defaultValue">
        <mat-radio-button
            class="accept-checkbox"
            name="cookie_choice"
            value="accept"
            (click)="updateUserChoiceStatus(true)"
            (keydown.enter)="updateUserChoiceStatus(true)"
            >Accept analytics cookies</mat-radio-button
        >
        <br />
        <mat-radio-button
            class="decline-checkbox"
            name="cookie_choice"
            value="decline"
            (click)="updateUserChoiceStatus(false)"
            (keydown.enter)="updateUserChoiceStatus(false)"
            checked
        >
            Decline analytics cookies</mat-radio-button
        >
    </div>
    <div class="cookie-buttons">
        <div class="save"><button (click)="save()" (keydown.enter)="save()">Save</button></div>
        <div class="cancel"><button (click)="cancel()" (keydown.enter)="cancel()">Cancel</button></div>
    </div>
</div>
